import { TSection } from '../../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsDeleteAllFromSectionDesktopRequestSchema';
import {
  TChatsBulkOperationsDeleteAllFromSectionDesktopResponse,
  fetchChatsBulkOperationsDeleteAllFromSectionDesktop,
} from '../../repositories/chats/v1/chats/bulk-operations/delete-all-from-section-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';
import { toggleChatListPending } from '../chatList/actions';

/**
 * Удалить все чаты
 * @param {ESection} section раздел в котором нужно удалить сообщения
 */
export const deleteAllChats =
  (section: TSection): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsDeleteAllFromSectionDesktopResponse =
        await fetchChatsBulkOperationsDeleteAllFromSectionDesktop({
          httpApi,
          parameters: {
            section,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode !== 200) {
        logger.warning('Код ответа не 200', {
          message: 'Не удалось удалить все чаты',
          domain: 'src/shared/actions/chatList/deleteAllChats.ts',
          statusCode,
          messsage: response.message || 'Неизвестная ошибка',
          errors: JSON.stringify(response?.errors),
        });

        dispatch(showAlert({ message: 'Не удалось удалить все чаты' }));
      }
    } catch (ex) {
      logger.error(ex, {
        message: 'Не удалось удалить все чаты',
        domain: 'src/shared/actions/chatList/deleteAllChats.ts',
      });

      dispatch(showAlert({ message: 'Не удалось удалить все чаты' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
